package article.spring

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material.Button
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.lerp


const val SPRING_ANIMATION = "d97d9d22c75d6a7049ad88e7f43e943687da688e480e0af32405c2e77a76d0d3"
@Composable
fun SpringAnimation() {


    var contracted by remember { mutableStateOf(false) }

    val height by animateFloatAsState(
        targetValue = if (contracted) .4f else 1f,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioHighBouncy,
            stiffness = Spring.StiffnessVeryLow,
            visibilityThreshold = .0001f
        ),
        visibilityThreshold = .01f
    )

//    val scale by animateFloatAsState(
//        targetValue = if (contracted) .5f else 1f,
//        animationSpec = spring()
//    )

    Box(Modifier.fillMaxSize()) {
        Column(
            Modifier.align(Alignment.TopCenter)
                .graphicsLayer {

                    transformOrigin = TransformOrigin(.5f, 0f)
                    scaleY = height
                }
        ) {
            for (i in 0..15) {
//                SpringCoil(lerp(10f, 20f, height).dp, i % 2 == 0)
                SpringCoil(10.dp, i % 2 == 0)
            }
        }

        Button(
            onClick = {
                contracted = !contracted
            },
            modifier = Modifier.align(Alignment.BottomEnd)
        ) {
            Text("Flip")
        }
    }

}

@Composable
private fun SpringCoil(height: Dp, flip: Boolean) {

    SideEffect { print("height = $height\n") }

    Box(Modifier
        .width(30.dp)
        .height(height)
        .scale(if (flip) -1f else 1f, 1f)
        .drawBehind {
            drawLine(
                color = Color(0xFFffffff),
                start = Offset.Zero,
                end = Offset(size.width, size.height),
                strokeWidth = 40f,
                cap = StrokeCap.Round,
            )
        }
    )

}